var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#2E2E2E",
    fontFamily: "ProximaNova-Extrabld, Proxima Nova",
    fontSize: 36,
    fontWeight: 600,
    transform: "translate(-974 -608)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 489,
    y: 627
  }, "Discount Gift Cards"), /*#__PURE__*/React.createElement("tspan", {
    x: 489,
    y: 671,
    fontFamily: "ProximaNova-Regular, Proxima Nova",
    fontSize: 14,
    fontWeight: "normal"
  }, "Save up to 7% when you buy discounted Nike gift cards from our marketplace.")), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E2E3",
    fillRule: "nonzero",
    d: "M9 0a9 9 0 10.002 18 9 9 0 00-.003-18zm0 3.318a1.404 1.404 0 110 2.807 1.404 1.404 0 010-2.807zM9 7.06c.342 0 .683.137.924.37.24.234.378.561.373.89v5.104c.005.33-.134.662-.38.895a1.34 1.34 0 01-1.848-.013 1.229 1.229 0 01-.367-.882V8.318a1.229 1.229 0 01.374-.889c.24-.233.58-.37.923-.37z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.1b030db5db7c44226816aaa567bc2c17.svg";
export { ForwardRef as ReactComponent };